import $ from "jquery";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		let $sections   = $( '#pageSections' );
		let $anchorLink = $( '#sectionsLink' );

		if ( $sections.length && $anchorLink.length ) {
			$anchorLink.on(
				'click touch',
				function( e ) {
					e.preventDefault();

					window.scrollTo(
						{
							top: $sections.position().top - 100,
							left: 0,
							behavior: 'smooth',
						}
					);
				}
			);
		}
	}
);
